import { ReferralType } from '@/services/dashboard/referralReports/referralReports.types';

type Translate = (key: string) => string;

export function getReferralTypeLabel(referralType: string | undefined | null, t: Translate) {
  if (referralType === ReferralType.direct || referralType === 'Direct') {
    return t('common.page.table.direct');
  }

  if (referralType === ReferralType.indirect || referralType === 'Indirect') {
    return t('common.page.table.indirect');
  }

  return '-';
}
